import {Component, ElementRef, NgZone, ViewChild} from '@angular/core';
import {
    App,
    Content,
    Keyboard,
    NavController,
    NavParams,
} from 'ionic-angular';

import {DomSanitizer} from "@angular/platform-browser";
import {YoutubeVideoPlayer} from '@ionic-native/youtube-video-player';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {CONFIG} from "../../../app/config";
import {TAction, TGaleriaTipo, TImageModel, TProdutoTipo, TProfileFlag, TProfileTeam} from "../../../app/enum";

import {LogadoService} from '../../../providers/logado-service';
import {DataService} from "../../../providers/data-service";

import {ProfileService} from "../../../providers/profile-service";
import {ProfilePagePage} from "../profile-page/profile-page";
import {ProfileBornPage} from "../profile-born/profile-born";
import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";

import {EntrakiOpenPage} from "../entraki-open/entraki-open";
import {SpotdayInfoPage} from "../spotday-info/spotday-info";

import {HotspotService} from "../../../providers/hotspot-service";
import {WebsiteSpotPage} from "../website-spot/website-spot";
import {PublicoMenuPage} from "../publico-menu/publico-menu";
import {ModalActionPage} from '../modal-action/modal-action';
import {MeritumMenuPage} from '../meritum-menu/meritum-menu';
import {WebstorService} from '../../../providers/webstor-service';
import {ProfileMenuPage} from '../profile-menu/profile-menu';
//import {SuperTabsController} from 'ionic2-super-tabs';

@Component({
    selector: 'page-rolezin-menu',
    templateUrl: 'rolezin-menu.html',
    providers: [WebstorService, HotspotService, ProfileService]
})

export class RolezinMenuPage {

    window: Window = window;

    TImageModel: any = TImageModel;
    TProfileFlag: any = TProfileFlag;

    config: any;
    logado: any;
    rootile: any;
    etapa: number;

    hoterror: any;
    hotfeeds: Array<any>;

    showVideo: any;
    players: any = {};

    tabindex: number = 0;
    page1: any;
    page2: any;

    scrollTime: number;
    scrollTopo: number = 0;
    alturaSize: number = 0;

    keyboardType: string;
    searchQtde: number = 0;
    searchFind: boolean;
    searchWork: boolean;
    searchBool: boolean;
    searchTerm: string;
    searchData: any = {Findonde: '', Findquem: '', Negocios: null, Spotdays: null, Profiles: null};

    @ViewChild(Content) content: Content;
    @ViewChild('feedloop') feedloop: ElementRef;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public app: App, private ngZone: NgZone,
                public keyboard: Keyboard,
                public dataService: DataService,
                public logadoService: LogadoService,
                public profileService: ProfileService,
                public hotspotService: HotspotService,
                public webstorService: WebstorService,
                //private superTabsCtrl: SuperTabsController,
                public youtube: YoutubeVideoPlayer, public sanitizer: DomSanitizer) {

        this.page1 = RolezinMenuPage;
        this.page2 = RolezinMenuPage;
            
        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.util.anyParams(this.logado, this.navParams.get('rootile'));
        this.etapa = this.util.anyParams(0, this.navParams.get('etapa'));

        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Rolezin', '/rolezin-menu');


        //KeyboardDidHide - Pesquisa se houver digitado
        // window.addEventListener('keyboardDidHide', () => {
        //     // Describe your logic which will be run each time keyboard is closed.
        //     if (this.dataService.get('tabselected') == 2 && this.navCtrl.getActive().name == 'ProcuraMenuPage') {
        //         this.searchChange();
        //     }
        // });

    }

    ngAfterViewInit() {

        //this.content.ionScroll.enableScrollListener();

        //GAMBI - ngZone - ACHO QUE ESSA MERDA QUE DA O NGZONE - TESTAR EXCLUINDO QUANDO FOR PUBLICAR O APP
        this.content.ionScroll.subscribe((scroll) => {

            //console.log('user scrolled', scroll);
    
            //#GAMB - Timeout para não ficar rodando sem respiro...
            clearTimeout(this.scrollTime);
            this.scrollTime = setTimeout(() => this.raincalc(scroll), 500);

        });

    }
    
    raincalc(scroll) {

        this.scrollTopo = scroll.scrollTop;
        this.alturaSize = this.feedloop ? this.feedloop.nativeElement.clientHeight : 0;
        this.ngZone.run(() => {});

    }

    rainbool(indexFeed, indexBase) : boolean {
        
        let indexCalc = Math.trunc(this.scrollTopo / (this.alturaSize || 1));
        let result = (indexCalc >= (indexFeed-2)) && (indexCalc <= (indexFeed+2)) && !!this.hotfeeds[indexFeed].Baseus[indexBase].Imagens[0].Bold;

        //console.log(result, indexCalc, this.alturaSize + '  -  ' + this.scrollTopo + '  -  ' + indexFeed + ' - ' + (this.scrollTopo / this.alturaSize));

        return result;

    }

    ionViewDidEnter() {

        if (this.etapa == 1 && !this.hotfeeds) this.hotfeedLoad();
        if (this.etapa == 2 && !this.hotfeeds) this.hotfeedLoad();

        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

    ionViewWillEnter() {


    }

    onTabSelect(event) {

        this.tabindex = event.index;
        this.searchFind = (this.tabindex == 0 ? this.searchData.Findonde : this.searchData.Findquem);

        //#Nao sei se funciona...
        //this.superTabsCtrl.showToolbar(false);

        this.procuraDone();
        
    }

    doScroll(event) {

        if (this.content.getScrollElement().scrollTop == 0) return;
        this.content.scrollTo(0, 0, 1000);
        this.hotfeedLoad();

    }

    hotfeedLoad(event?: any) {

        let action = (this.etapa == 1 ? TAction.acOnde : TAction.acQuem);
        this.profileService.hotfeed(action, this.rootile.Profile.ProfileID)
            .finally(() => {
                if (event) event.complete();
                this.showVideo = false;
            })
            .subscribe(
                data => {

                    this.hoterror = null;
                    this.hotfeeds = data.Hotfeeds;
                    this.ngZone.run(() => {});


                    //Processa Galeria
                    this.hotfeeds.forEach(root => {

                        root.Baseus.forEach(base => {

                            if (base.Imagens.length && base.Imagens[0].Type == '#IMAGEM#') {

                                base.lgData = [];
                                base.Imagens.forEach(profile => {

                                    if (profile.Type == '#IMAGEM#') {
                                        let push = {'src': profile.Link, 'thumb': profile.Link, 'subHtml': '<h4>' + profile.Text + '</h4>'};
                                        base.lgData.push(push);
                                    }

                                });

                            }

                        });

                    });

                    //FOTO OPEN: ABRIR FOTO!
                    //(<any>window).$(this.ambientes.nativeElement).lightGallery({share: false, hash: false});

                },
                erro => {

                    this.hotfeeds = null;
                    this.hoterror = erro;

                });

    }

    publicoFind(root, base, item, press: boolean = false) {

        //PRIVACY-SPOT - Verified
        if (!this.privacySpot()) return;

        let hotspotID = (base ? base.Codigo : 0);
        let paybookBase = (base ? base.Params.split('=')[1] : '');

        let branded = null;
        if (hotspotID) branded = {BrandedID: 0, BrandedShow: base.Titulos[0].Text, BrandedBase: base.Backgd, BrandedCora: base.Imagens[0].Tint};

        let object = {etapa: 0, rootile: this.rootile, hotspotID: hotspotID, paybookBase: paybookBase, paybookFull: press, branded: branded};
        this.util.navActive(this.navCtrl).push(PublicoMenuPage, object, {animation: 'md-transition'});

    }

    entrakiOpen(item, button) {

        let paybook = {PaybookID: button.Open, Branded: {BrandedShow: button.Text, BrandedBase: button.Link}};
        let object = {etapa: 4, checkinSelf: false, paybook: paybook, hotspot: null, spotdayID: 0};
        this.util.modalopen(EntrakiOpenPage, 'quad', true, object).subscribe(
            data => {

                //Checkin Feedback
                if (item && data && data.success) {

                    //Delete Bloco anterior "Titulo" e "Conteudo" (proximo bloco)
                    let canalIndex = this.hotfeeds.indexOf(item);
                    this.hotfeeds.splice(canalIndex - 1, 2);

                }

        });

    }

    profileBorn(hotspotID) {

        let data = {hotspotID: hotspotID};
        this.util.navActive(this.navCtrl).push(ProfileBornPage, data);

    }

    privacySpot() {

        //PRIVACY-SPOT - Verified
        if (this.rootile.Profile.PrivacySpot) return true;


        let onOkey = (okey, that, data) => {

            this.privacyMenu(that);

        };

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'animeload', onOkey, null, false, null, null)};
        objectData.modalinfo.window = 'animeerro';
        objectData.modalinfo.corcor = 'CorRoxa';
        objectData.modalinfo.header = null;
        objectData.modalinfo.titulo = null;
        objectData.modalinfo.resumo = 'Para visualizar o rolê, você precisa ativar sua <b>privacidade de checkin</b>, então, seus seguidores <b>poderão ver você também</b>.';
        objectData.modalinfo.imagem = 'b-icon-lock';
        objectData.modalinfo.stores = false;
        objectData.modalinfo.action = {name: 'Continuar', round: false, small: false, plus: null};
        objectData.modalinfo.observ = null;
        objectData.modalinfo.linhas = null;

        this.util.modalopen(ModalActionPage, 'quad', true, objectData).subscribe(
            data => this.util.dismissToViewName(this.navCtrl, 'ConnectPayoutPage')
        );

        return false;

    }

    galeriaView(item, base) {

        let hotspotID = base.Titulos[0].Open;
        let galeriaID = item.Open;
        let galeriaTipo = item.More;

        let loading = this.util.loadingDots();
        loading.present();

        this.hotspotService.galeria(TAction.acLoad, hotspotID, galeriaID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let keyname = TGaleriaTipo[galeriaTipo].substring(2, 10) + 's';
                    let galerias = data.Galerias[keyname];

                    this.util.midiasee(galeriaTipo, galerias[0]);

                },
                erro => {

                    this.util.alertResult(erro);

                }
            );

    }

    pressed(name, root, base, item?, button?) {

        this.clicked(name, root, base, item, button, true);
        this.util.vibrate(50);

    }

    profilePage(profileID, profileCnpj?) {

        //MANAGER-OLHA
        if (profileCnpj) {
            if (this.logado.Profile.ProfileTeam < TProfileTeam.mkManager) return;

            let object = {profileSpot: true, profileID: profileID, rootile: null};
            this.util.modalopen(ProfileMenuPage, 'alto', false, object).subscribe();    
            return;
        }


        //PRIVACY-SPOT - Verified
        if (!this.privacySpot()) return;

        let object = {profileID: profileID};
        this.util.navActive(this.navCtrl).push(ProfilePagePage, object);

    }

    spotdayOpen(spotdayID) {

        let object = {etapa: 0, spotdayID: spotdayID};
        this.util.modalopen(SpotdayInfoPage, 'alto', false, object).subscribe();

    }

    meritumPage(branded) {

        let meritum = {BrandedID: branded.BrandedID};
        let object = {etapa: 1, rootile: this.logado, meritums: [meritum], produtoTipo: TProdutoTipo.ptNone};
        this.util.navActive(this.navCtrl).push(MeritumMenuPage, object);

    }

    hotspotPage(hotspotID, branded) {

        let object = {hotspotID: hotspotID, brandex: branded, tabmenu: true};
        this.util.navActive(this.navCtrl).push(WebsiteSpotPage, object);

    }

    hotspotPush(branded) {

        if (branded.BrandedSpots.length == 1) {
            this.hotspotPage(branded.BrandedSpots[0].HotspotID, branded);
            return;
        }

        /** OPEN **/
        let buttons: Array<any> = [];
        branded.BrandedSpots.forEach(spot => {
            buttons.push({text: spot.Unidades[0].UnidadeNome, handler: () => this.hotspotPage(spot.HotspotID, spot.Unidades[0].Branded)});
        });
        this.util.sheetOpen(buttons, 'HOTSPOT');

    }

    atracaoDate() {
        
    }

    privacyMenu(that?) {

        let copy = this.util.deepCopy(this.logado);

        let object = {etapa: 4, rootile: this.logado, copyile: copy};
        this.util.modalopen(PrivacyMenuPage, 'alto', false, object)
            .finally(() => {
                //if (this.logado.Profile.PrivacySpot) this.hotfeedLoad();
            })
            .subscribe();

        //Close modal de pergunta privacy
        if (that) setTimeout(() => that.dismiss(), 1000);

    }

    clicked(name, root, base, item, button?, press?) {

        if (name == '#IMAGEM#') this.galeriaView(item, base);

        if (name == '#PROFILE#') this.profilePage(item.Open);

        if (name == '#PRIVACY#') this.privacyMenu();

        if (name == '#MATILHA#') this.publicoFind(root, base, item, press);

        if (name == '#BIRTHDAY#') this.profileBorn(item.Open);

        if (name == '#HOTPAGE#') this.hotspotPage(item.Open, {BrandedLogo: item.Link});

        if (name == '#FEEDBACK#') this.entrakiOpen(item, button);

        if (name == '#SPOTDAY#') this.spotdayOpen(item.Open);

        if (name == '#OLHAPAY#') this.publicoFind(null, null, null, press);
      //if (name == '#OLHAPAY#') this.publicoFind(root, base, item, press);

        if (name == '#SPOTAPP#') this.util.baixarApp();

    }

    youtubesave(player, id) {

        this.players[id] = player;

    }

    youtubechange(player, id) {

        if (player.data == 0) this.showVideo = false;

    }

    dismiss() {

        if (this.logado.Profile.ProfileID == this.rootile.Profile.ProfileID) return;

        this.navCtrl.pop();

    }

    baseArray(base): any[] {

        let calc = (this.logado.Profile.ProfileZito ? 3 : 4);
        let qtde = base.Scroll ? base.Imagens.length : calc;
        return base.Imagens.slice(0, qtde);

    }





    procuraDone(bool: boolean = false) {

        this.keyboardType = (this.tabindex == 0 ? 'text' : 'tel');
        this.searchTerm = (this.tabindex == 0 ? this.searchData.Findonde : this.searchData.Findquem);
        this.searchBool = bool;

    }

    searchChange() {

        //Database Field na Bridge tem tamanho de 45 para gravar a pesquisa.
        if (this.searchTerm && this.searchTerm.length > 45) this.searchTerm = this.searchTerm.slice(0, 45);


        this.searchQtde++;
        if (this.tabindex == 0) this.procuraOnde();
        if (this.tabindex == 1) this.procuraQuem();

    }

    tamanhoSize(): boolean {

        let negocioBool = (this.tabindex == 0 && this.searchData && this.searchData.Negocios && this.searchData.Negocios.length);
        let spotdayBool = (this.tabindex == 0 && this.searchData && this.searchData.Spotdays && this.searchData.Spotdays.length);
        let profileBool = (this.tabindex == 1 && this.searchData && this.searchData.Profiles && this.searchData.Profiles.length);
        return this.searchBool && (negocioBool || spotdayBool || profileBool);

    }

    procuraOnde() {

        this.keyboard.close();

        let searchQtde = this.searchQtde;

        this.searchData.Findonde = '';
        this.searchData.Negocios = null;
        this.searchData.Spotdays = null;
        this.searchFind = false;

        if (!this.searchTerm || this.searchTerm.length <= 3) return;

        if (this.searchWork) return;
        this.searchWork = true;
        this.ngZone.run(() => {});

        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Procura', '/procura-menu?term=' + this.searchTerm);

        //Requisicao
        this.webstorService.webstor(TAction.acLupa, 0, 0, '', false, false, this.searchTerm)
            .finally(() => {
                this.searchWork = false;
                this.ngZone.run(() => {});
            })
            .subscribe(
                data => {

                    if (this.searchQtde != searchQtde) return;

                    this.searchData.Findonde = this.searchTerm;
                    this.searchData.Negocios = data.Negocios;
                    this.searchData.Spotdays = data.Spotdays;
                    
                    this.searchFind = true;
                    this.ngZone.run(() => {});

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }

    procuraQuem() {

        this.keyboard.close();

        let searchQtde = this.searchQtde;

        this.searchData.Findquem = '';
        this.searchData.Profiles = null;
        this.searchFind = false;

        if (!this.searchTerm || this.searchTerm.length <= 3) return;

        //CNPJ/CNPF - Format
        if (this.util.validaCNPF(this.searchTerm)) this.searchTerm = this.util.formatDOC(this.searchTerm);
        if (this.util.validaCNPJ(this.searchTerm)) this.searchTerm = this.util.formatDOC(this.searchTerm);
        
        if (this.searchWork) return;
        this.searchWork = true;
        this.ngZone.run(() => {});

        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Procura', '/procura-menu?term=' + this.searchTerm);

        //Requisicao
        this.profileService.profile(TAction.acLupa, 0, null, '&Pesquisa=' + this.searchTerm)
            .finally(() => {
                this.searchWork = false;
                this.ngZone.run(() => {});
            })
            .subscribe(
                data => {

                    if (this.searchQtde != searchQtde) return;

                    this.searchData.Findquem = this.searchTerm;
                    this.searchData.Profiles = data.Profiles;

                    this.searchFind = true;
                    this.ngZone.run(() => {});

                },
                erro => {

                    this.util.alertResult(erro);

                });
    }


}



// WEBPACK FOOTER //
// ./src/pages/sync/rolezin-menu/rolezin-menu.ts